<script>
  import { Icon } from 'element-ui'
  export default {
    name:'ElIcon',
    extends:Icon
  }
</script>
